export const TEST_PROFILE_COLORS = {
    LOGIC_TEST: '#27ccc0'
};
